import { useTenant } from '@emerald-works-nova/auth'
import { useMemo } from 'react'
import { ALLOW_REPORTING_GROUP } from '../components/user-group-policy/permissions'
import consts from '../consts'
import useGroup from './useGroup'

const useProducts = () => {
  const tenant = useTenant()
  const isClub = tenant.pk === consts.DEFAULT_CLUB_PK
  const { isInGroup } = useGroup()

  const hasContentHubAccess = useMemo(() => {
    if (isClub) return true

    const hasContentHubField = Object.hasOwn(tenant.features, 'contentHub')
    const { contentHub } = tenant.features
    return hasContentHubField ? contentHub : true
  }, [tenant, isClub])

  const hasMsaAccess = useMemo(() => {
    return tenant.features?.assessment?.enabled ?? tenant.features?.msa ?? false
  }, [tenant])

  const hasMsbAccess = useMemo(() => {
    return tenant.features?.msb ?? false
  }, [tenant])

  const hasSkillBitesAccess = useMemo(() => {
    return tenant.features?.skillBite?.enabled
  }, [tenant])

  const isSkillBitesFlexibleSchedulingEnabled = useMemo(() => {
    return tenant.features?.skillBite?.flexibleScheduling ?? false
  }, [tenant])

  const isCredlyBadgesEnabled = useMemo(() => {
    return tenant.features?.skillBite?.credlyBadges ?? false
  }, [tenant])

  const hasSkillsPracticeAccess = useMemo(() => {
    if (isClub) return false
    return tenant.features?.skillsPractice?.enabled === true
  }, [tenant, isClub])

  const msaActiveAssessmentId = tenant.features?.assessment?.activeAssessmentId ?? 'manager-skill-assessment'

  const hasLPQAccess = useMemo(() => {
    return tenant.features?.lpq?.enabled ?? true
  }, [tenant])

  const showLPQModalPopup = useMemo(() => {
    return tenant.features?.lpq?.showModalPopup ?? true
  }, [tenant])

  const lpqMandatory = useMemo(() => {
    return !(tenant.features?.lpq?.isOptional ?? true)
  }, [tenant])

  const hasReportingAccess = useMemo(() => {
    return (hasContentHubAccess || hasSkillBitesAccess) && isInGroup(ALLOW_REPORTING_GROUP)
  }, [hasContentHubAccess, hasSkillBitesAccess, isInGroup])

  return {
    hasContentHubAccess,
    hasMsaAccess,
    hasMsbAccess,
    hasSkillBitesAccess,
    hasSkillsPracticeAccess,
    hasReportingAccess,
    hasMsaAssessmentAccess: (assessmentId) => msaActiveAssessmentId === assessmentId,
    msaActiveAssessmentId,
    isSkillBitesFlexibleSchedulingEnabled,
    isCredlyBadgesEnabled,
    hasLPQAccess,
    showLPQModalPopup,
    lpqMandatory
  }
}

export default useProducts
